var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_9570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7322 21.58C16.6122 27.24 21.2522 31.86 26.9122 34.76L31.3122 30.36C31.8522 29.82 32.6522 29.64 33.3522 29.88C35.5922 30.62 38.0122 31.02 40.4922 31.02C41.5922 31.02 42.4922 31.92 42.4922 33.02V40C42.4922 41.1 41.5922 42 40.4922 42C21.7122 42 6.49219 26.78 6.49219 8C6.49219 6.9 7.39219 6 8.49219 6H15.4922C16.5922 6 17.4922 6.9 17.4922 8C17.4922 10.5 17.8922 12.9 18.6322 15.14C18.8522 15.84 18.6922 16.62 18.1322 17.18L13.7322 21.58Z",
    fill: "#FFD96B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_9570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0492,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.c9c6a756c5e78e3745dc7dd92da134be.svg";
export { ForwardRef as ReactComponent };